/**
 * Created by DynamicDog on 2016-12-03.
 *
 * The actual etikett editing content.
 * Has a menu to select a style, a carousel with etiketts, font selection toggle and font size selection.
 * TODO: Create slider for font size.
 * TODO: Dropdown for font styles.
 */
import {Component,Input,ViewChild,  trigger,
    state,
    style,
    transition,
    animate} from '@angular/core';
import {EtikettCarouselComponent} from './etikettcarousel.component';
import {EtikettService} from "../services/etikett.service";
var $ = window['$'];
@Component({
    selector: 'etikett-panel',
    animations: [
        trigger('heroState', [
            state('inactive', style({
                overflow:'hidden',
                height:'0px'
            })),
            state('active',   style({
                overflow:'hidden',
                height:'690px'
            })),

            transition('inactive => active', animate('100ms ease-in')),
            transition('active => inactive', animate('100ms 100ms ease-out'))
        ])
    ],
    template: `   
                <div class="etikett-panel"  [hidden]="!etikett.open">
                    <div class="menu">
                        <div *ngFor="let category of etikettService.labelCategories" class="menu-item clickable" style="text-transform:uppercase" (click)="onClick(category)" [ngClass]="{active: etikett.mode===category}">{{category|translate}}</div>
                    </div>

                    <etikett-carousel [etikett]="etikett"></etikett-carousel>
                    
                    <div class="font-bar">
                        <div style="display:inline-block;margin-left:15px;margin-right:15px">
                            <div style="padding-top:10px;font-weight:bold;display:none;">Aa |</div> 
                            <md-select [(ngModel)]="etikett.font">
                                <md-option *ngFor="let font of fonts" [value]="font.value">{{ font.name|translate }}</md-option>
                            </md-select>
                        </div>
                        <div style="display:none;margin-left:15px;margin-right:15px">
                            <div style="display:inline-block;font-weight:bold;line-height:48px">{{etikett.fontSize}}px</div>
                            <md-slider min="0" [max]="getFontSizeCount()" class="clickable" step="1" [(ngModel)]='fontIndex' (input)="onFontSizeChange($event)"></md-slider>
                        </div>
                    </div>
                </div>


`,
})
export class EtikettPanelComponent {
    @Input() etikett: any;
    @Input() index:number;
    @Input('hidden')
    set hidden(value: boolean) {
        
    }
    private fontIndex = 1;
    private fontSizes:Array<number> = [
        36,
        40,
        48,
        56,
        64
    ];

    private fonts: Array<any> =
        [
            { name: 'Plain', value: 'plain', disabled: false },
            { name: 'Italic', value: 'italic', disabled: false }
        ];
    // Reference to the carousel component
    @ViewChild(EtikettCarouselComponent) carousel:EtikettCarouselComponent;

    constructor(private etikettService:EtikettService) {

    }

    ngAfterViewInit() {
        var fontSize = this.etikett['fontSize'];
        for(var i = 0; i < this.fontSizes.length;i++) {
            if(fontSize === this.fontSizes[i]) {
                this.fontIndex = i;
            }
        }
    }
    private getFontSizeCount() : number {
        return this.fontSizes.length-1;
    }
    private onFontSizeChange(event:any):void  {
        this.etikett.fontSize = this.fontSizes[event.value];
    }
    public onOpen() {
        
    }
    private onClick(mode:string) {
        // If we change a category, reset to the first image in that category
        // in order to avoid selecting an image outside of the range.
        this.etikett.mode = mode;
        this.etikett.image = 0;
        this.carousel.warp(0);
    }

    private onClickFont(font:string) {
        this.etikett['font'] = font;
    }
}


// WEBPACK FOOTER //
// ./app/etikett/etikettpanel.component.ts